import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenErrorTemplateComponent } from "../loren-error-template/loren-error-template.component";

@Component({
    selector: "loren-error-not-found",
    imports: [TranslocoPipe, LorenErrorTemplateComponent],
    templateUrl: "./loren-error-not-found.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./loren-error-not-found.component.scss"
})
export class LorenErrorNotFoundComponent {}
